import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule, SERVICE_WORKER, VAPID_KEY } from '@angular/fire/compat/messaging';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { RoutingModule } from './routing.module';
import { interceptorProviders } from './system/core/interceptors/interceptors';
import { AppLayoutModule } from './system/layout/app.layout.module';
import { PrimengModule } from './system/primeng/primeng.module';
import { MessagesService } from './system/services/message.service';
import { SharedModule } from './system/shared/shared.module';

registerLocaleData(localeEs);

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppLayoutModule,
    LayoutModule,
    PrimengModule,
    SharedModule,
    RoutingModule,
    NgxDropzoneModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule
  ],
  declarations: [
    AppComponent,
  ],
  providers: [
    interceptorProviders,
    DialogService,
    MessagesService,
    MessageService,
    { provide: LOCALE_ID, useValue: 'es-ES' },
    {
      provide: VAPID_KEY,
      useValue: environment.vapidKey
    },
    {
      provide: SERVICE_WORKER,
      useFactory: () => {
        if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
          return navigator.serviceWorker.register('/firebase-messaging-sw.js', {
            scope: '/'
          });
        }

        return Promise.reject('Service Worker not supported');
      }
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
